import React from 'react';

function BlogPagination({ currentPage, totalPages, onPageChange, hasMore }) {
    if (!totalPages || totalPages <= 1) {
        return null; // Don't show pagination if there's only one page or no pages
    }

    const handlePageClick = (pageNumber, event) => {
        event.preventDefault();
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            onPageChange(pageNumber);
        }
    };

    const generatePageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            // Show all pages if total is small
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show limited pages with ellipsis
            if (currentPage <= 3) {
                // Show first 3 pages + ellipsis + last page
                for (let i = 1; i <= 3; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                // Show first page + ellipsis + last 3 pages
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 2; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                // Show first page + ellipsis + current page + ellipsis + last page
                pages.push(1);
                pages.push('...');
                pages.push(currentPage);
                pages.push('...');
                pages.push(totalPages);
            }
        }
        
        return pages;
    };

    return (
        <div>
            <div className="row">
                <div className="col">
                    <div className="pagination-container">
                        <ul className="page-numbers">
                            {/* Previous button */}
                            {currentPage > 1 && (
                                <li>
                                    <a
                                        href="#"
                                        className="page-numbers prev"
                                        onClick={(e) => handlePageClick(currentPage - 1, e)}
                                        aria-label="Previous page"
                                    >
                                        <i className="fas fa-chevron-left"></i>
                                    </a>
                                </li>
                            )}
                            
                            {/* Page numbers */}
                            {generatePageNumbers().map((page, index) => (
                                <li key={index}>
                                    {page === '...' ? (
                                        <span className="page-numbers dots">...</span>
                                    ) : (
                                        <a
                                            href="#"
                                            className={`page-numbers ${currentPage === page ? 'current' : ''}`}
                                            onClick={(e) => handlePageClick(page, e)}
                                        >
                                            {page}
                                        </a>
                                    )}
                                </li>
                            ))}
                            
                            {/* Next button */}
                            {hasMore && (
                                <li>
                                    <a
                                        href="#"
                                        className="page-numbers next"
                                        onClick={(e) => handlePageClick(currentPage + 1, e)}
                                        aria-label="Next page"
                                    >
                                        <i className="fas fa-chevron-right"></i>
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlogPagination;
